var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramBookmark = function SvgInstagramBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666664",
    d: "M17.032.294H1.095a.469.469 0 0 0-.469.469v20.625a.469.469 0 0 0 .794.337l7.643-7.374 7.644 7.374a.468.468 0 0 0 .794-.337V.763a.469.469 0 0 0-.469-.47Zm-.468 19.99-7.175-6.921a.468.468 0 0 0-.65 0l-7.176 6.921V1.231h15v19.053Z"
  })));
};
export default SvgInstagramBookmark;